import { SkatingLesson } from '../@types';
import { RequestApi } from '../helpers';

const getSkatingLessons = async () => {
  const response = await RequestApi.get<SkatingLesson[]>(`/skatinglesson`);
  return response;
};

const createSkatingLessonBooking = async (userData: FormData) => {
  const response = await RequestApi.post(
    '/skatingLesson/createLessonBooking',
    userData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

const skatingLessonService = {
  getSkatingLessons,
  createSkatingLessonBooking,
};

export default skatingLessonService;
